/* eslint-disable import/no-cycle */
// eslint-disable-next-line import/no-cycle
import { FC } from 'react';
import clsx from 'clsx';
import dynamic from 'next/dynamic';

import Button, { ThemeType } from '../Button';
import ChallengeCard from '../FeaturedChallenge';
import { IFeaturedContentBladeProps } from '../../blades/featuredContentBlade/@types';
import ImageComponent from '../Image';
import RichText from '../RichText';
import SectionWrapper from '../SectionWrapper';
import Skillbuilder from '../Skillbuilder';
import Typo from '../Typo';
import styles from './featuredContent.module.sass';
import { useIsMobileViewport } from '../../hooks/useIsMobileViewport';

const GridLines = dynamic(() => import('../Icons/GridLines'), {
  ssr: false,
});

const Header: FC<IFeaturedContentBladeProps> = ({ heading, subHeading, description, type }) => {
  const textColor = type === 'Challenge' ? 'is-color-White' : 'is-color-Black';
  return (
    <div className={`${styles.bladeText}`}>
      {heading && (
        <Typo h2 classes={`${styles.mainHeading} ${textColor}`}>
          {heading}
        </Typo>
      )}
      {subHeading && (
        <Typo h3 classes={clsx(textColor, styles.subHeading, 'mb-4')}>
          {subHeading}
        </Typo>
      )}
      {description && (
        <Typo normal classes={clsx(textColor)}>
          <RichText classes={styles.description} document={description} />
        </Typo>
      )}
    </div>
  );
};

const ChallengeContainer: FC<IFeaturedContentBladeProps & { isMobile: boolean }> = ({
  isMobile,
  card,
}) => {
  return (
    <>
      <div className={`${styles.artistContainer}`}>
        <div>
          <ImageComponent
            image="/static/images/homePage/featuredContent/circle_green.svg"
            width={isMobile ? '60px' : '145px'}
            height={isMobile ? '60px' : '145px'}
            classes={`${styles.borderCircle}`}
          />
          <ImageComponent
            image="/static/images/homePage/heroBlade/circlePoints.svg"
            width={isMobile ? '57px' : '146px'}
            height={isMobile ? '57px' : '146px'}
            classes={`${styles.pointedCircle}`}
          />
        </div>
      </div>
      <ChallengeCard {...card} />
    </>
  );
};

const FeaturedContent: FC<IFeaturedContentBladeProps> = props => {
  const { isMobile } = useIsMobileViewport();
  const { card, type, link, commonProperties } = props;

  return (
    <SectionWrapper
      hasBodyMargin={!isMobile}
      classes={styles.featuredContentContainer}
      backgroundColor={commonProperties?.fields?.backgroundColor}
      childClasses={clsx('has-text-centered py-6', {
        [styles.challengeContainer]: type === 'Challenge' && !isMobile,
      })}
    >
      {type === 'Skillbuilder' && <GridLines className={styles.gridBackground} />}
      <div
        className={clsx(styles.contentCard, {
          [styles.contentCardChallenge]: type === 'Challenge',
        })}
      >
        <Header {...props} />
        {type === 'Challenge' ? (
          <ChallengeContainer {...props} isMobile={isMobile} />
        ) : (
          <Skillbuilder {...card} />
        )}
      </div>
      {link && (
        <Button theme={link.fields.layout as ThemeType} link={link} classes={`${styles.button}`} />
      )}
    </SectionWrapper>
  );
};

export default FeaturedContent;
